// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ConfigService } from '@par/app/core/services/config.service';
import { GetRegionsResponse } from '@par/app/core/data-services/model/get-regions.response';
import { Region } from './model/region';

@Injectable({
  providedIn: 'root',
})
export class RegionsDataService {
  private response$: Observable<GetRegionsResponse>;

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getRegions(): Observable<GetRegionsResponse> {
    if (!this.response$) {
      const url = this.configService.getConfig().partnersApi + '/regions';
      let params = new HttpParams();
      params = params.set('page', '0');
      params = params.set('size', '1000');

      this.response$ = this.httpClient
        .get<GetRegionsResponse>(url, {params})
        .pipe(shareReplay(1));
    }
    return this.response$;
  }

  getRegion(regionId: string): Observable<Region> {
    if (!regionId) {
      return undefined;
    }

    return this
      .getRegions()
      .pipe(map((regions) => regions
        .content
        .find(region => region.id.toString() === regionId?.toString())));
  }

  clear(): void {
    this.response$ = undefined;
  }
}
